import { render, staticRenderFns } from "./EditQuote.vue?vue&type=template&id=6136b8ec&"
import script from "./EditQuote.vue?vue&type=script&lang=js&"
export * from "./EditQuote.vue?vue&type=script&lang=js&"
import style0 from "./EditQuote.vue?vue&type=style&index=0&id=6136b8ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports